import { render, staticRenderFns } from "./Return_product_detail.vue?vue&type=template&id=644ea2ab&scoped=true&"
import script from "./Return_product_detail.vue?vue&type=script&lang=js&"
export * from "./Return_product_detail.vue?vue&type=script&lang=js&"
import style0 from "./Return_product_detail.vue?vue&type=style&index=0&id=644ea2ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644ea2ab",
  null
  
)

export default component.exports